// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FormLayout_form__FtMkB {
    margin: auto;
    width: 100%;
    flex: 1 1;
    display: flex;
    /*flex-direction: column;*/
    /*align-items: center;*/
    /*justify-content: center;*/
    /*padding-bottom: 30px;*/
}

.FormLayout_form__FtMkB.FormLayout_absolute__bEwpx .FormLayout_footer__I0wEn {
    padding-top: 24px;
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]} {
    .FormLayout_form__FtMkB:not(.FormLayout_absolute__bEwpx) .FormLayout_formContent__WXHKl {
        /*min-height: 900px;*/
        /*min-width: 1000px;*/
    }
}

@media (min-height: 1080px) {
    .FormLayout_form__FtMkB:not(.FormLayout_absolute__bEwpx) .FormLayout_formContent__WXHKl {
        min-height: 860px;
    }
}

.FormLayout_form__FtMkB.FormLayout_md__\\+ce1N .FormLayout_formContent__WXHKl {
    min-width: 768px;
}

.FormLayout_formContent__WXHKl {
    position: relative;
    width: 100%;
    /*border: 0.25px solid #707070;*/
    /*background: rgba(251, 251, 252);*/
    /*padding: 20px 34px 55px;*/
    /*border-radius: 3px;*/
    display: flex;
    flex-direction: column;
}

.FormLayout_separator__oDdkP {
    border: 0;
    border-bottom: 1px solid var(--light-grey);
    /*margin: 0 calc(var(--padding-x) * -1) 0;*/
    /*width: calc(100% + var(--padding-x) * 2);*/
    width: 100%;
}

.FormLayout_separatorMargin__Iw3Vt {
    margin-bottom: 30px;
}

.FormLayout_header__FeBds {
    --offset: 26px;
    /*padding: 0 0 24px;*/
    /*margin: 0 calc(var(--offset) * -1);*/
    /*width: calc(100% + calc(var(--offset) * 2));*/
    /*position: sticky;*/
    /*top: 0;*/
    /*background-color: #fbfbfb;*/
    /*z-index: 2;*/
    padding: 20px var(--padding-x);
    position: sticky;
    top: 0;
    background: #fbfbfc;
    border-bottom: 1px solid var(--light-grey);
    z-index: 2;
}

/*.header.margin {*/
/*    margin-bottom: 32px;*/
/*}*/

.FormLayout_headerRow__hpIJV {
    margin-bottom: 25px;
}

.FormLayout_header__FeBds div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    grid-gap: 16px;
}

.FormLayout_header__FeBds h3 {
    font-size: 30px;
    font-weight: 600;
    margin: 0;
}

.FormLayout_header__FeBds p {
    margin: 30px 0 0;
    color: #7b848e;
    font-weight: 500;
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .FormLayout_header__FeBds h3 {
        font-size: 25px;
    }

    .FormLayout_header__FeBds p {
        font-size: 16px;
        line-height: 18px;
    }

    .FormLayout_separatorMargin__Iw3Vt {
        margin-bottom: 20px;
    }
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]} {
    .FormLayout_header__FeBds p {
        font-size: 19px;
        line-height: 25px;
    }
}

.FormLayout_absolute__bEwpx {
    position: absolute;
    z-index: 10;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 35px;
    width: 100%;
    height: 100%;
}

.FormLayout_absolute__bEwpx:before {
    content: '';
    width: 100%;
    height: 100%;
    background: rgba(214, 214, 214, 0.5);
    display: block;
    position: absolute;
    top: 0;
    left: 0;
}

.FormLayout_absolute__bEwpx .FormLayout_formContent__WXHKl {
    margin: auto;
    /*background-color: #fbfbfb;*/
    padding: 0 24px;
    /*border: 0.35px solid #707070;*/
    /*border-radius: 2px;*/
    /*max-height: calc(100vh - var(--header-height) - 110px);*/
    /*overflow: auto;*/
    width: 680px;
    max-width: 100%;
    max-height: 100%;
    /*max-width: 680px;*/
    /*max-width: fit-content;*/

    overflow-y: auto;
    overflow-x: hidden;

    background: #fbfbfc;
    border-radius: 6px;
    border: 4px double rgba(112, 112, 112, 0.25);
}

.FormLayout_footer__I0wEn {
    text-align: right;
    margin-top: auto;
    display: flex;

    justify-content: space-between;
    padding: 0 var(--padding-x);
}

.FormLayout_footerAdditional__ZDCi- {
    margin-bottom: 60px;
    text-align: right;
    display: flex;
    padding: 0 var(--padding-x);
}

.FormLayout_footerAdditionalInner__8pd-N {
    max-width: 562px;
    margin: 0 0 0 auto;
}

.FormLayout_footerAdditionalGrid__1oZVT {
    padding-left: 142px;
    width: calc(50% - 48px / 2);
}

.FormLayout_formGridRow__vZ6p2 {
    /*margin-bottom: 40px;*/
    display: flex;
    grid-gap: 48px;
    justify-content: space-between;
    /*grid-template-columns: repeat(2, 1fr);*/
}

.FormLayout_formRow__ZeFl3:not(:last-child) {
    border-bottom: 1px solid var(--light-grey);
    margin-bottom: 24px;
}

.FormLayout_mainContent__2haOR {
}

.FormLayout_mainContentPadding__WhReJ {
    padding: 0 var(--padding-x);
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-max"]} {
    .FormLayout_footerAdditionalInner__8pd-N {
        max-width: 442px;
    }
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .FormLayout_footerAdditionalInner__8pd-N {
        max-width: 442px;
    }
}

@media (max-height: 1260px) {
    .FormLayout_form__FtMkB:not(.FormLayout_absolute__bEwpx) .FormLayout_formContent__WXHKl {
        min-height: calc(100vh - var(--header-height) - 220px);
    }
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .FormLayout_form__FtMkB:not(.FormLayout_absolute__bEwpx) .FormLayout_formContent__WXHKl {
        /*min-width: 590px;*/
        max-width: 100%;
    }

    .FormLayout_form__FtMkB.FormLayout_md__\\+ce1N .FormLayout_formContent__WXHKl {
        min-width: 768px;
    }

    .FormLayout_absolute__bEwpx .FormLayout_formContent__WXHKl {
        /*background-color: #fbfbfb;*/
        padding: 0 0 20px;
    }

    /*.header.margin {*/
    /*    margin-bottom: 20px;*/
    /*}*/

    .FormLayout_headerRow__hpIJV {
        margin-bottom: 20px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Storage/layout/FormLayout/FormLayout.module.css"],"names":[],"mappings":"AAEA;IACI,YAAY;IACZ,WAAW;IACX,SAAO;IACP,aAAa;IACb,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,qBAAqB;QACrB,qBAAqB;IACzB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gCAAgC;IAChC,mCAAmC;IACnC,2BAA2B;IAC3B,sBAAsB;IACtB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,0CAA0C;IAC1C,2CAA2C;IAC3C,4CAA4C;IAC5C,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,sCAAsC;IACtC,+CAA+C;IAC/C,oBAAoB;IACpB,UAAU;IACV,6BAA6B;IAC7B,cAAc;IACd,8BAA8B;IAC9B,gBAAgB;IAChB,MAAM;IACN,mBAAmB;IACnB,0CAA0C;IAC1C,UAAU;AACd;;AAEA,mBAAmB;AACnB,2BAA2B;AAC3B,IAAI;;AAEJ;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,gCAAgC;IAChC,sBAAsB;IACtB,0DAA0D;IAC1D,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,0BAA0B;;IAE1B,gBAAgB;IAChB,kBAAkB;;IAElB,mBAAmB;IACnB,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;;IAEb,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,cAAc;IACd,8BAA8B;IAC9B,yCAAyC;AAC7C;;AAEA;IACI,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;AACA;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,sDAAsD;IAC1D;AACJ;;AAEA;IACI;QACI,oBAAoB;QACpB,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,6BAA6B;QAC7B,iBAAiB;IACrB;;IAEA,mBAAmB;IACnB,2BAA2B;IAC3B,IAAI;;IAEJ;QACI,mBAAmB;IACvB;AACJ","sourcesContent":["@value screen-lg-min, screen-lg-max, screen-md-max from '../../../../breakpoints.css';\n\n.form {\n    margin: auto;\n    width: 100%;\n    flex: 1;\n    display: flex;\n    /*flex-direction: column;*/\n    /*align-items: center;*/\n    /*justify-content: center;*/\n    /*padding-bottom: 30px;*/\n}\n\n.form.absolute .footer {\n    padding-top: 24px;\n}\n\n@media screen-lg-min {\n    .form:not(.absolute) .formContent {\n        /*min-height: 900px;*/\n        /*min-width: 1000px;*/\n    }\n}\n\n@media (min-height: 1080px) {\n    .form:not(.absolute) .formContent {\n        min-height: 860px;\n    }\n}\n\n.form.md .formContent {\n    min-width: 768px;\n}\n\n.formContent {\n    position: relative;\n    width: 100%;\n    /*border: 0.25px solid #707070;*/\n    /*background: rgba(251, 251, 252);*/\n    /*padding: 20px 34px 55px;*/\n    /*border-radius: 3px;*/\n    display: flex;\n    flex-direction: column;\n}\n\n.separator {\n    border: 0;\n    border-bottom: 1px solid var(--light-grey);\n    /*margin: 0 calc(var(--padding-x) * -1) 0;*/\n    /*width: calc(100% + var(--padding-x) * 2);*/\n    width: 100%;\n}\n\n.separatorMargin {\n    margin-bottom: 30px;\n}\n\n.header {\n    --offset: 26px;\n    /*padding: 0 0 24px;*/\n    /*margin: 0 calc(var(--offset) * -1);*/\n    /*width: calc(100% + calc(var(--offset) * 2));*/\n    /*position: sticky;*/\n    /*top: 0;*/\n    /*background-color: #fbfbfb;*/\n    /*z-index: 2;*/\n    padding: 20px var(--padding-x);\n    position: sticky;\n    top: 0;\n    background: #fbfbfc;\n    border-bottom: 1px solid var(--light-grey);\n    z-index: 2;\n}\n\n/*.header.margin {*/\n/*    margin-bottom: 32px;*/\n/*}*/\n\n.headerRow {\n    margin-bottom: 25px;\n}\n\n.header div {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    grid-gap: 16px;\n}\n\n.header h3 {\n    font-size: 30px;\n    font-weight: 600;\n    margin: 0;\n}\n\n.header p {\n    margin: 30px 0 0;\n    color: #7b848e;\n    font-weight: 500;\n}\n\n@media screen-md-max {\n    .header h3 {\n        font-size: 25px;\n    }\n\n    .header p {\n        font-size: 16px;\n        line-height: 18px;\n    }\n\n    .separatorMargin {\n        margin-bottom: 20px;\n    }\n}\n\n@media screen-lg-min {\n    .header p {\n        font-size: 19px;\n        line-height: 25px;\n    }\n}\n\n.absolute {\n    position: absolute;\n    z-index: 10;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    padding: 35px;\n    width: 100%;\n    height: 100%;\n}\n\n.absolute:before {\n    content: '';\n    width: 100%;\n    height: 100%;\n    background: rgba(214, 214, 214, 0.5);\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n\n.absolute .formContent {\n    margin: auto;\n    /*background-color: #fbfbfb;*/\n    padding: 0 24px;\n    /*border: 0.35px solid #707070;*/\n    /*border-radius: 2px;*/\n    /*max-height: calc(100vh - var(--header-height) - 110px);*/\n    /*overflow: auto;*/\n    width: 680px;\n    max-width: 100%;\n    max-height: 100%;\n    /*max-width: 680px;*/\n    /*max-width: fit-content;*/\n\n    overflow-y: auto;\n    overflow-x: hidden;\n\n    background: #fbfbfc;\n    border-radius: 6px;\n    border: 4px double rgba(112, 112, 112, 0.25);\n}\n\n.footer {\n    text-align: right;\n    margin-top: auto;\n    display: flex;\n\n    justify-content: space-between;\n    padding: 0 var(--padding-x);\n}\n\n.footerAdditional {\n    margin-bottom: 60px;\n    text-align: right;\n    display: flex;\n    padding: 0 var(--padding-x);\n}\n\n.footerAdditionalInner {\n    max-width: 562px;\n    margin: 0 0 0 auto;\n}\n\n.footerAdditionalGrid {\n    padding-left: 142px;\n    width: calc(50% - 48px / 2);\n}\n\n.formGridRow {\n    /*margin-bottom: 40px;*/\n    display: flex;\n    grid-gap: 48px;\n    justify-content: space-between;\n    /*grid-template-columns: repeat(2, 1fr);*/\n}\n\n.formRow:not(:last-child) {\n    border-bottom: 1px solid var(--light-grey);\n    margin-bottom: 24px;\n}\n\n.mainContent {\n}\n\n.mainContentPadding {\n    padding: 0 var(--padding-x);\n}\n\n@media screen-lg-max {\n    .footerAdditionalInner {\n        max-width: 442px;\n    }\n}\n\n@media screen-md-max {\n    .footerAdditionalInner {\n        max-width: 442px;\n    }\n}\n\n@media (max-height: 1260px) {\n    .form:not(.absolute) .formContent {\n        min-height: calc(100vh - var(--header-height) - 220px);\n    }\n}\n\n@media screen-md-max {\n    .form:not(.absolute) .formContent {\n        /*min-width: 590px;*/\n        max-width: 100%;\n    }\n\n    .form.md .formContent {\n        min-width: 768px;\n    }\n\n    .absolute .formContent {\n        /*background-color: #fbfbfb;*/\n        padding: 0 0 20px;\n    }\n\n    /*.header.margin {*/\n    /*    margin-bottom: 20px;*/\n    /*}*/\n\n    .headerRow {\n        margin-bottom: 20px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-lg-min": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]}`,
	"screen-lg-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-max"]}`,
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"form": `FormLayout_form__FtMkB`,
	"absolute": `FormLayout_absolute__bEwpx`,
	"footer": `FormLayout_footer__I0wEn`,
	"formContent": `FormLayout_formContent__WXHKl`,
	"md": `FormLayout_md__+ce1N`,
	"separator": `FormLayout_separator__oDdkP`,
	"separatorMargin": `FormLayout_separatorMargin__Iw3Vt`,
	"header": `FormLayout_header__FeBds`,
	"headerRow": `FormLayout_headerRow__hpIJV`,
	"footerAdditional": `FormLayout_footerAdditional__ZDCi-`,
	"footerAdditionalInner": `FormLayout_footerAdditionalInner__8pd-N`,
	"footerAdditionalGrid": `FormLayout_footerAdditionalGrid__1oZVT`,
	"formGridRow": `FormLayout_formGridRow__vZ6p2`,
	"formRow": `FormLayout_formRow__ZeFl3`,
	"mainContent": `FormLayout_mainContent__2haOR`,
	"mainContentPadding": `FormLayout_mainContentPadding__WhReJ`
};
export default ___CSS_LOADER_EXPORT___;
